import axios from '@axios'

export const state = {
  option: {},
}

export const getters = {
  allOption: (state) => state.option,
}

export const mutations = {
  GET_OPTION: (state, resp) => {
    if (!resp) return null
    state.option = resp.data
  },
}

export const actions = {
  async getOption({ commit }) {
    return axios.get('/api/options')
  },
  async updateOption({ commit }, option) {
    return axios.put('/api/options', option)
  },
}
